import { h } from 'preact'
import { isTouchDevice, tagParser, linkParser } from '../../js/modules/utilities.js'
import { useState } from 'preact/hooks'

var isSmartphone = require('is-mobile')

export const bannierePlaceholder = `
   #postCommande.placeholder,
   #monAutreBannier.placeholder {
      min-height: 355px;
      @media (max-width: 960px) {
         min-height: 423px;
      }
      @media (max-width: 479px) {
         min-height: calc((100vw * (520 / 480)) + 30px);
      }
   }
`

// /!\ Composant Banniere2images fork de Banniere qui permet de gérer les bannières lorsque advise n'envoi que 2 images et pas 3
// /!\ Utilisé uniquement pour Foisonnement et JeuxVideo

export const Banniere2images = ({
   format,
   tag,
   date,
   title,
   description,
   legals,
   legalNotice,
   images,
   URL,
   textColor,
   analytics,
   cacheKey,
   alt,
   index,
   device = isSmartphone() ? 'mobile' : 'desktop',
}) => {
   title = tagParser(title)
   description = tagParser(description)
   legals = tagParser(legals)
   let adviseTags = {}
   if (analytics.pdbSc === 'adv') {
      adviseTags = {
         'data-pdb-ta': analytics.pdbTa,
         'data-adv-canal': analytics.advCanal,
         'data-adv-cappingdata': analytics.advCappingdata,
      }
   }

   return (
      <div class={`banner-wrapper position-relative format-${format}`}>
         <a
            href={URL}
            class={`small-height banniere2images textcolor-${textColor}`}
            data-testid="banner"
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={images.img1}
            {...adviseTags}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
            data-cache-key={cacheKey}
         >
            {device === 'mobile' ? <PictureMobile images={images} alt={alt} /> : <PictureDesktop format={format} images={images} alt={alt} />}
            {(tag || date || title || description || legals) && <Content tag={tag} date={date} title={title} description={description} legals={legals} />}
         </a>
         {(legalNotice.content || legalNotice.title) && <LegalNotice {...legalNotice} index={index} />}
      </div>
   )
}

const getTagBgColor = (tag) => {
   if (tag && tag.indexOf('[tagwhite]') !== -1) {
      return 'white'
   } else {
      return 'yellow'
   }
}

const getTagText = (tag) => {
   if (tag) {
      tag = tag.replace(/\[.*?\]/g, '')
      return tag
   } else {
      return ''
   }
}

const Content = ({ tag, date, title, description, legals }) => {
   return (
      <div class="wrapper">
         <div class="content">
            {(tag || date) && (
               <div class="top">
                  {tag && <span class={`ob1-tag ${getTagBgColor(tag) === 'white' ? 'ob1-tag-white' : 'ob1-tag-primary'}`}>{getTagText(tag)}</span>}
                  {date && <span class="date">{date}</span>}
               </div>
            )}
            {title && <h3 class="title" dangerouslySetInnerHTML={{ __html: title }}></h3>}
            {description && <p class="description" dangerouslySetInnerHTML={{ __html: description }}></p>}

            {legals && (
               <div class="bottom">
                  <p class="legals" dangerouslySetInnerHTML={{ __html: legals }}></p>
               </div>
            )}
         </div>
      </div>
   )
}

const LegalNotice = ({ showButtonLabel, title, content, background, index = 0 }) => {
   const [legalState, setLegalState] = useState(false)
   const [legalHoverState, setLegalHoverState] = useState(false)

   const toggleLegals = () => {
      setLegalState(!legalState)
      if (legalState === false) {
         pauseCarrousel()
      } else {
         resetCarrousel()
      }
   }

   const showLegals = () => {
      if (!isTouchDevice()) setLegalHoverState(true)
   }

   const hideLegals = () => {
      if (!isTouchDevice()) setLegalHoverState(false)
   }

   const pauseCarrousel = () => {
      const isCarrouselPlaying = document.querySelector('.glide__playpause--pause') ? true : false
      if (isCarrouselPlaying) {
         document.querySelector('.glide__playpause').classList.add('pauseByLegals')
         document.querySelector('.glide__playpause').click()
      }
   }

   const resetCarrousel = () => {
      const isCarrouselPause = document.querySelector('.glide__playpause--play') ? true : false
      if (isCarrouselPause) {
         let isCarrouselPausedByLegal = document.querySelector('.glide__playpause.pauseByLegals') ? true : false
         if (isCarrouselPausedByLegal) {
            document.querySelector('.glide__playpause').click()
            document.querySelector('.glide__playpause').classList.remove('pauseByLegals')
         }
      }
   }

   return (
      <div
         class={`bannerLegalNotice ${legalState ? 'openContent' : ''} ${legalHoverState ? 'isHover' : ''} ${background === 'white' ? 'grey-bg' : 'black-bg'}`}
         onMouseLeave={hideLegals}
      >
         <div id={`legalNoticePanel${index}`} class="contentLegalNotice" aria-hidden={!legalState}>
            <span class="closeLegal" onClick={toggleLegals}>
               &times;
            </span>
            <div class="contentText">
               {title && <div class="legalNoticeTitle" dangerouslySetInnerHTML={{ __html: tagParser(title) }}></div>}
               {content && <div dangerouslySetInnerHTML={{ __html: tagParser(linkParser(content)) }}></div>}
            </div>
         </div>
         <span
            class="showButton"
            onClick={toggleLegals}
            onMouseEnter={showLegals}
            tabindex="0"
            role="button"
            aria-expanded={legalState}
            aria-pressed={legalState}
            aria-controls={`legalNoticePanel${index}`}
         >
            <span class="showButton-label">{showButtonLabel}</span>&nbsp;<span class="icon icon-info"></span>
         </span>
      </div>
   )
}

const PictureDesktop = ({ format, images, alt }) => {
   // img1: 1500x380
   // img2: 1800x720
   let balisePicture = (
      <picture>
         <source srcset={`${images.img2}?saveas=webp`} media="(max-width: 959px)" />
         <source srcset={`${images.img1}?saveas=webp`} media="(max-width: 1199px)" />
         <img class="background-img" src={`${images.img1}?saveas=webp`} alt={alt} loading="lazy" />
      </picture>
   )

   // img1: 1200x388
   // img2: 1800x720
   // ex: n-1 tv
   if (format === '1200x388-960x1040') {
      balisePicture = (
         <picture>
            <source srcset={`${images.img2}?saveas=webp`} media="(max-width: 959px)" />
            <source srcset={`${images.img1}?saveas=webp`} media="(max-width: 1199px)" />
            <img class="background-img" src={`${images.img1}?crop=960,310,0,39&saveas=webp`} alt={alt} loading="lazy" />
         </picture>
      )
   }

   return balisePicture
}

const PictureMobile = ({ images, alt }) => {
   // HP / boutique
   // img1: 960x800
   // img2: 1800x720

   // TV / Mobile&Forfait
   // img1: 960x1040
   // img2: 1800x720
   return (
      <picture>
         <source srcset={`${images.img1}?saveas=webp`} media="(max-width: 479px)" />
         <img src={`${images.img2}?saveas=webp`} alt={alt} class="background-img" loading="lazy" />
      </picture>
   )
}
